var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebPrCollaborators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_5018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83267 11.9065C10.8401 11.9065 12.4736 10.273 12.4736 8.26559C12.4736 6.2582 10.8401 4.62463 8.83267 4.62463C6.82528 4.62463 5.19171 6.2582 5.19171 8.26559C5.19171 10.273 6.82528 11.9065 8.83267 11.9065ZM8.83267 6.44515C9.83633 6.44515 10.6531 7.26193 10.6531 8.26559C10.6531 9.26925 9.83633 10.086 8.83267 10.086C7.82901 10.086 7.01222 9.26925 7.01222 8.26559C7.01222 7.26193 7.82901 6.44515 8.83267 6.44515Z",
    fill: "url(#paint0_linear_169_5018)",
    stroke: "url(#paint1_linear_169_5018)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10165 23.7438H6.10055C5.5987 23.7438 5.18904 23.3342 5.18904 22.8323V18.2799C5.18904 16.2725 6.82262 14.6389 8.83 14.6389C9.80043 14.6389 10.717 15.0178 11.4058 15.6989C12.092 16.3954 12.471 17.312 12.471 18.2824V19.1939C12.471 19.6958 12.8781 20.1054 13.3825 20.1054C13.8843 20.1054 14.294 19.6983 14.294 19.1939V14.6415C14.294 12.6341 15.9275 11.0005 17.9349 11.0005C18.9053 11.0005 19.822 11.3794 20.5107 12.0605C21.1969 12.757 21.5759 13.6736 21.5759 14.644V19.1965C21.5759 19.6983 21.983 20.108 22.4874 20.108C22.9892 20.108 23.3989 19.7009 23.3989 19.1965V14.644C23.3989 13.1923 22.833 11.8198 21.7986 10.7752C20.7591 9.74849 19.3892 9.18262 17.9349 9.18262C15.0596 9.18262 12.7039 11.4153 12.494 14.2369C11.4826 13.328 10.1947 12.8261 8.83256 12.8261C5.82145 12.8261 3.37115 15.2765 3.37115 18.2875V22.84C3.37115 24.3455 4.59505 25.572 6.10317 25.572H7.10427C7.60612 25.572 8.01577 25.1649 8.01577 24.6605C8.01577 24.1587 7.60867 23.749 7.10427 23.749L7.10165 23.7438Z",
    fill: "url(#paint2_linear_169_5018)",
    stroke: "url(#paint3_linear_169_5018)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9376 8.2658C19.945 8.2658 21.5785 6.63223 21.5785 4.62484C21.5785 2.61746 19.945 0.983887 17.9376 0.983887C15.9302 0.983887 14.2966 2.61746 14.2966 4.62484C14.2966 6.63223 15.9302 8.2658 17.9376 8.2658ZM17.9376 2.8044C18.9412 2.8044 19.758 3.62118 19.758 4.62484C19.758 5.6285 18.9412 6.44529 17.9376 6.44529C16.9339 6.44529 16.1171 5.6285 16.1171 4.62484C16.1171 3.62118 16.9339 2.8044 17.9376 2.8044Z",
    fill: "url(#paint4_linear_169_5018)",
    stroke: "url(#paint5_linear_169_5018)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_5018",
    x1: 3.27853,
    y1: 48.3541,
    x2: 30.3107,
    y2: 33.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_5018",
    x1: 3.27853,
    y1: 48.3541,
    x2: 30.3107,
    y2: 33.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_5018",
    x1: -1.89075,
    y1: 107.604,
    x2: 64.7222,
    y2: 62.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_169_5018",
    x1: -1.89075,
    y1: 107.604,
    x2: 64.7222,
    y2: 62.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_169_5018",
    x1: 12.3834,
    y1: 44.7134,
    x2: 39.4156,
    y2: 29.7143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_169_5018",
    x1: 12.3834,
    y1: 44.7134,
    x2: 39.4156,
    y2: 29.7143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_5018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.5963,
    height: 25.8396,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.0870361 26.1979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebPrCollaborators);
export default __webpack_public_path__ + "static/media/web_PR_collaborators.d9d2508f6a5ce956329994b6ec12a700.svg";
export { ForwardRef as ReactComponent };